import styled from 'styled-components';
import { Button, Card } from 'antd';

export const StyledButton = styled(Button)`
  margin: 1rem 0 0 0;
`;

export const StyledCard = styled(Card)`
  margin: 0 0 1rem 0;
`;
